// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.triaphon-mdx-editor {
  --accentBase: #002fa7;
  --accentBgSubtle: #002fa7;
  --accentBg: #002fa7;
  --accentBgHover: #002fa7;
  --accentBgActive: #002fa7;
  --accentSolid: #002fa7;
  --accentSolidHover: #002fa7;

  --baseBase: #fff;

  --font-body: "Roboto", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", "Ubuntu", sans-serif;
}

.triaphon-mdx-editor a {
  color: #002fa7;
}

.mdxeditor-root-contenteditable {
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  min-height: 150px;
}

.mdxeditor-toolbar {
  padding: 4px 2px;
  background-color: transparent;
}

.mdxeditor-toolbar button {
  cursor: pointer;
}

.mdxeditor-popup-container {
  z-index: 1500;
}

.mdxeditor-popup-container button {
  cursor: pointer;
}

.mdxeditor-popup-container button[type="submit"],
.mdxeditor-popup-container button[type="reset"] {
  margin-top: 8px;
  border-radius: 4px;
  font-weight: bold;
  padding: 8px 16px;
}

.mdxeditor-popup-container button[type="submit"] {
  border: none;
}

.mdxeditor-popup-container button[type="submit"]:hover {
  background-color: rgb(0, 32, 116);
}

.mdxeditor-popup-container button[type="reset"] {
  background-color: rgb(241, 243, 247);
  color: #002fa7;
  border: none;
}

.mdxeditor-popup-container button[type="reset"]:hover {
  background-color: rgb(224, 228, 240);
}

.mdxeditor-toolbar button[role="combobox"] {
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
}

.mdxeditor-root-contenteditable > div > div > p:first-child {
  margin-top: 0;
}

.mdxeditor-root-contenteditable li[role="checkbox"]::before {
  top: 4px;
}

.mdxeditor-root-contenteditable li[role="checkbox"]::after {
  top: 7px;
}

.triaphon-mdx-editor--fullscreen {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.triaphon-mdx-editor--fullscreen .mdxeditor-toolbar {
  flex-shrink: 0;
}

.triaphon-mdx-editor--fullscreen .mdxeditor-root-contenteditable {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.triaphon-mdx-editor--fullscreen .mdxeditor-root-contenteditable > div {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./frontend/mdx-editor-overrides.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;;EAE3B,gBAAgB;;EAEhB,4GAA4G;AAC9G;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".triaphon-mdx-editor {\n  --accentBase: #002fa7;\n  --accentBgSubtle: #002fa7;\n  --accentBg: #002fa7;\n  --accentBgHover: #002fa7;\n  --accentBgActive: #002fa7;\n  --accentSolid: #002fa7;\n  --accentSolidHover: #002fa7;\n\n  --baseBase: #fff;\n\n  --font-body: \"Roboto\", \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Ubuntu\", sans-serif;\n}\n\n.triaphon-mdx-editor a {\n  color: #002fa7;\n}\n\n.mdxeditor-root-contenteditable {\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  border-radius: 4px;\n  min-height: 150px;\n}\n\n.mdxeditor-toolbar {\n  padding: 4px 2px;\n  background-color: transparent;\n}\n\n.mdxeditor-toolbar button {\n  cursor: pointer;\n}\n\n.mdxeditor-popup-container {\n  z-index: 1500;\n}\n\n.mdxeditor-popup-container button {\n  cursor: pointer;\n}\n\n.mdxeditor-popup-container button[type=\"submit\"],\n.mdxeditor-popup-container button[type=\"reset\"] {\n  margin-top: 8px;\n  border-radius: 4px;\n  font-weight: bold;\n  padding: 8px 16px;\n}\n\n.mdxeditor-popup-container button[type=\"submit\"] {\n  border: none;\n}\n\n.mdxeditor-popup-container button[type=\"submit\"]:hover {\n  background-color: rgb(0, 32, 116);\n}\n\n.mdxeditor-popup-container button[type=\"reset\"] {\n  background-color: rgb(241, 243, 247);\n  color: #002fa7;\n  border: none;\n}\n\n.mdxeditor-popup-container button[type=\"reset\"]:hover {\n  background-color: rgb(224, 228, 240);\n}\n\n.mdxeditor-toolbar button[role=\"combobox\"] {\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  border-radius: 4px;\n}\n\n.mdxeditor-root-contenteditable > div > div > p:first-child {\n  margin-top: 0;\n}\n\n.mdxeditor-root-contenteditable li[role=\"checkbox\"]::before {\n  top: 4px;\n}\n\n.mdxeditor-root-contenteditable li[role=\"checkbox\"]::after {\n  top: 7px;\n}\n\n.triaphon-mdx-editor--fullscreen {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.triaphon-mdx-editor--fullscreen .mdxeditor-toolbar {\n  flex-shrink: 0;\n}\n\n.triaphon-mdx-editor--fullscreen .mdxeditor-root-contenteditable {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.triaphon-mdx-editor--fullscreen .mdxeditor-root-contenteditable > div {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
